import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, isRef as _isRef, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2df9f1c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, null, -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "bar" }
const _hoisted_6 = { class: "main" }
const _hoisted_7 = { class: "main" }
const _hoisted_8 = { id: "burger" }
const _hoisted_9 = {
  key: 0,
  class: "main"
}

import CartLink from './Modules/CartLink.vue';
    import LogoModule from './Modules/LogoModule.vue';
    import NavLinks from './Modules/NavLinks.vue';
    import AuthModule from './Modules/AuthModule.vue';
    import ButtonBurger from '@/components/UI/ButtonBurger.vue';

    import { computed, ref, onMounted, onUnmounted} from 'vue';


    //Захаркоженые ссылки
    
export default /*#__PURE__*/_defineComponent({
  __name: 'NavBarMain',
  setup(__props) {

    let links = [
        {
            routerPath: `${process.env.VUE_APP_BASE_URL}catalog`,
            name: 'каталог'
        }, 
        {
            routerPath: 'https://t.me/+3MYe4VjwLTcyMjBi',
            name: 'НОВОСТИ'
        }, 
        {
            routerPath: 'https://t.me/+aSkMrcMrGY85M2My',
            name: 'TESLA CHAT'
        }, 
        {
            routerPath: 'https://t.me/teslalabz_bot',
            name: 'Бот для заказов'
        }, 
    ]

    //Проверяем длину окна чтобы отображать для мобилок и пк
    let windowWidth = ref(ref(window.innerWidth))

    const onWidthChange = () => windowWidth.value = window.innerWidth
    onMounted(() => window.addEventListener('resize', onWidthChange))
    onUnmounted(() => window.removeEventListener('resize', onWidthChange))

    //Переключалка на мобильном баре
    let isToggle = ref(false)

    //Возвращение бургер кнопки в исходное положение
    let updateKey = ref(0)
    function forseUpdate(){
        updateKey.value++
    }


return (_ctx: any,_cache: any) => {
  return (_unref(windowWidth) >= 720)
    ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(LogoModule, {
            imageStyle: '23',
            textStyle: 1.4
          }),
          _hoisted_3,
          true
            ? (_openBlock(), _createBlock(NavLinks, {
                key: 0,
                links: _unref(links)
              }, null, 8, ["links"]))
            : _createCommentVNode("", true),
          _createVNode(CartLink),
          _createVNode(AuthModule)
        ])
      ]))
    : (_openBlock(), _createElementBlock("header", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(LogoModule, {
              imageStyle: '18',
              textStyle: 1.1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              (_openBlock(), _createBlock(ButtonBurger, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(isToggle) //@ts-ignore
 ? isToggle.value = !_unref(isToggle) : isToggle = !_unref(isToggle))),
                key: _unref(updateKey)
              }))
            ])
          ]),
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              (_unref(isToggle))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(NavLinks, {
                      links: _unref(links),
                      onClose: _cache[1] || (_cache[1] = ($event: any) => {_isRef(isToggle) //@ts-ignore
 ? isToggle.value = false : isToggle = false; forseUpdate()})
                    }, null, 8, ["links"]),
                    _createVNode(CartLink, {
                      onClose: _cache[2] || (_cache[2] = ($event: any) => {_isRef(isToggle) //@ts-ignore
 ? isToggle.value = false : isToggle = false; forseUpdate()})
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(AuthModule, {
                        onClose: _cache[3] || (_cache[3] = ($event: any) => (forseUpdate()))
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]))
}
}

})